import { useNFCSState } from 'modules/nfcs/hooks/useNFCSState'
import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { Text } from 'shared/ui/common/Text'

import { ReactComponent as WarningMarkSVG } from 'assets/warningMark.svg'
import { ReactComponent as YoutubeSVG } from 'assets/social-youtube.svg'
import { ReactComponent as InfoSVG } from 'assets/info.svg'

import s from './NFCSFormMintDescription.module.scss'
import { NFCSFormStep } from 'modules/nfcs/types'

export const NFCSFormMintDescription = () => {
  const { walletAddress } = useWeb3()
  const { currentFormStep, signedAddresses } = useNFCSState()

  if (currentFormStep === NFCSFormStep.Start) {
    return (
      <>
        <Text color="secondary" size={14} isCentered>
          First, before minting NFCS make sure that you have connected to the
          <br />
          primary address, i.e. address from which you are going to borrow.
        </Text>
        <Text color="inherit" size={14} isCentered className={s.warningNote}>
          <WarningMarkSVG /> Note! This action cannot be reverted or changed.
        </Text>
      </>
    )
  }

  if (currentFormStep === NFCSFormStep.Intermediate) {
    return (
      <>
        <Text color="secondary" size={14} weight={500} isCentered>
          In order to improve your scoring, add more addresses with DeFi
          <br />
          transaction history to NFCS
        </Text>
        <div className={s.mediaLinks}>
          <a
            className={s.mediaLink}
            href="https://www.youtube.com/watch?v=mXYY3ey2jso&ab_channel=RociFi"
            target="_blank"
            rel="noreferrer"
          >
            See video <YoutubeSVG />
          </a>
          <a
            className={s.mediaLink}
            href="https://blog.roci.fi/nfcs-bundling-tutorial-48363e34baca"
            target="_blank"
            rel="noreferrer"
          >
            Read instructions <InfoSVG />
          </a>
        </div>
      </>
    )
  }

  return (
    <>
      <Text color="secondary" size={14} isCentered className={s.lastStep}>
        Sign your primary address by clicking a button below
      </Text>
      {walletAddress && walletAddress !== signedAddresses[0] && (
        <Text color="inherit" size={14} isCentered className={s.warningNote}>
          You must re-connect to the primary address before initiating NFCS mint
        </Text>
      )}
    </>
  )
}
